module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACwAAAAeCAYAAAEgMcwxAAAAAXNSR0IArs4c6QAAANtJREFUWAntVsERwjAMs3t5sAQzhGcnYQ8WgWnoCgxC9zCBRx9tfBcd0aPgvlpXUWw5J0ftnk2QR70VSURvNSZ3xQZcRVZ51ab83Kx3AoVBZuffd+Fqwh4lBE6itJyn/PByXMeTmIzrYJfvosbp2spUOmiXVjCkcyvpPnEhxdI3mhQ04mHJvfMLz1s6J7pjuveAanZZpE6aI9OOG1Ldj2OLV7QPPUQLaEAixLRTQbNNpDoES1MCSSKwocA/KRAuwe52uQwejuxNgj8UICoQLkEU90OdZNAze5Oe/C8lgzxh2fW8NwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/menu-amarelo-weblivro.png
// module id = 470
// module chunks = 0